import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=0acad39d&scoped=true"
import script from "./MiPerfil.vue?vue&type=script&lang=js"
export * from "./MiPerfil.vue?vue&type=script&lang=js"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=0acad39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acad39d",
  null
  
)

export default component.exports